import React, { useEffect, useState } from 'react';
const START_SECONDS = 23 * 3600 + 59 * 60 + 52;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: string;
    label: string;
  }> = [{
    value: pad(hours),
    label: 'HRS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="flex items-center justify-center gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-46" data-mp="374mas3fanb4y">
      {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-47" data-mp="y0esg83rqo4n" data-mpi={index}>
          <div className="min-w-[86px] rounded-md border border-line bg-ink px-3 py-3 text-center md:min-w-[110px]" data-id="element-48" data-mp="xz3ly0ixv29u">
            <div className="font-display text-4xl font-extrabold leading-none text-white tabular-nums md:text-5xl" data-id="element-49" data-mp="17qzw49yauiuf">
              {unit.value}
            </div>
            <div className="mt-1 text-[11px] font-semibold tracking-[0.2em] text-slate-400" data-id="element-50" data-mp="12sety4zhlp3c">
              {unit.label}
            </div>
          </div>
          {index < units.length - 1 && <span className="font-display text-3xl text-accent md:text-4xl" aria-hidden="true" data-id="element-51" data-mp="a4sh064dd83t">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}